// styles
import classNames from "classnames";

// constants
import { LINKS } from "./constants";
import styles from "./styles.module.scss";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.container}>
      <div className={styles.links}>
        <a
          className={classNames(styles.text, "p2", "g600")}
          target="_blank"
          href="https://waffyapp.com/privacy-policy-ar/"
          rel="noreferrer">
          {LINKS.PRIVACY}
        </a>
        <div className={styles.divider} />
        <a
          className={classNames(styles.text, "p2", "g600")}
          target="_blank"
          href="https://waffyapp.com/terms-of-service-ar/"
          rel="noreferrer">
          {LINKS.TERMS}
        </a>
      </div>
      <p
        className={classNames(
          "p2",
          "g900"
        )}>{`${LINKS.RIGHTS_RESERVED} ${currentYear}`}</p>
    </div>
  );
};

export default Footer;
